import React from 'react';
import PropTypes from 'prop-types';
import './PageLayout.css';

/**
 * PageLayout - Componente template para layouts de página
 * 
 * Este componente define a estrutura básica de uma página,
 * incluindo cabeçalho, barra lateral, conteúdo principal e rodapé.
 * Segue o princípio do Atomic Design como um "template".
 */
const PageLayout = ({
  header,
  sidebar,
  content,
  footer,
  className = '',
  ...props
}) => {
  return (
    <div className={`page-layout ${className}`} {...props}>
      {/* Cabeçalho */}
      {header && (
        <header className="page-layout__header">
          {header}
        </header>
      )}
      
      <div className="page-layout__main">
        {/* Barra lateral */}
        {sidebar && (
          <aside className="page-layout__sidebar">
            {sidebar}
          </aside>
        )}
        
        {/* Conteúdo principal */}
        <main className="page-layout__content">
          {content}
        </main>
      </div>
      
      {/* Rodapé */}
      {footer && (
        <footer className="page-layout__footer">
          {footer}
        </footer>
      )}
    </div>
  );
};

PageLayout.propTypes = {
  header: PropTypes.node,
  sidebar: PropTypes.node,
  content: PropTypes.node.isRequired,
  footer: PropTypes.node,
  className: PropTypes.string
};

export default PageLayout;